import { render } from "./worldwidetopcrearor.vue?vue&type=template&id=5ba1d71d"
import script from "./worldwidetopcrearor.vue?vue&type=script&lang=js"
export * from "./worldwidetopcrearor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__